var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7710_66017)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7710_66017)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7710_66017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5871 54.9435V90.4609C89.5871 92.7097 86.8371 95.1747 84.557 95.0431L13.9795 95.0337C11.8747 94.8928 9.40979 92.5782 9.40979 90.4609V54.9435H3.19581C2.94525 54.9435 1.26021 53.8849 0.990852 53.6312C-1.04811 51.7269 -0.935356 48.3443 0.968928 46.3868L45.2749 6.99502C47.9183 4.33591 51.0754 4.33278 53.722 6.99502L98.0279 46.3868C99.9479 48.3975 100.045 51.658 98.0029 53.6281C97.6552 53.9632 96.1957 54.9435 95.8011 54.9435H89.5871Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7710_66017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7710_66017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(-0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7710_66017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 90.0495,
    fill: "white",
    transform: "translate(-0.5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a729228f5d416dc5bbc78891d42bd5a3.svg";
export { ForwardRef as ReactComponent };